import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { Grid, Icon } from "semantic-ui-react";
import { formatDataProperties, handleFormChange } from "../../../Helpers";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import BCButton from "../../ui/BCButton";
import BCDashboard from "../../ui/BCDashboard";
import BCEmptyState from "../../ui/BCEmptyState";
import BCFormInput from "../../ui/BCFormInput";
import BCTable from "../../ui/BCTable";

const BWLoanDrawDetailProcess = ({
  isGreaterThanMobile, 
  isGreaterThanTablet, 
  isSidebar, 
  brokerColor,
  loanProps
}) => {
  const [loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj] = useState({} as any);

  const history = useHistory();
  const handleBackHome = useCallback(() => {
    history.push("/");
  }, [history]);

  const convertubmittedDetailToTableFormat = (details) => {
    const submittedDetailsTable = [] as any[];
    let totalAmount = 0;
    for (const info in details){
      const detail = details[info];
      totalAmount += detail.drawRequestAmount;
      submittedDetailsTable.push({
        "id": detail.id,
        "category": detail.category,
        "subCategory": detail.subCategory,
        "vendor": detail.vendor,
        "requestedAmount": `$${detail.drawRequestAmount}`,
      });
    }

    submittedDetailsTable.push({"requestedAmount": `$${totalAmount}`});
    return formatDataProperties(submittedDetailsTable);
  };

  const LoanDetailProcessLayout = [
    [
      {
        title: <React.Fragment>
        <div className="breadcrumbs">
          <div className="breadcrumbs-home" onClick={() => handleBackHome()}><Icon name="home" />Home</div>
          <div> &gt; </div>
          <div className="breadcrumbs-current">{loanProps.loan} - {loanProps.loanProperty}</div>
        </div>
      </React.Fragment>,
        size: 16,
        headerOptions: [
          <BCButton handleOnClick={() => history.goBack()}>Previous</BCButton>,
          <BCButton handleOnClick={() => console.log("Confirm")}>Confirm</BCButton>
        ],
        content: <React.Fragment>
          {convertubmittedDetailToTableFormat(loanProps.loanDrawRequestInfo).length > 0 ? <React.Fragment>
            <div>
              <BCTable 
                data={convertubmittedDetailToTableFormat(loanProps.loanDrawRequestInfo)}
                dataRules={[
                  { field: "Loan Draw Application Id", rule: "hide" },
                  { field: "Id", rule: "hide" },
                  { field: "Sort Order", rule: "hide" },
                ]}
                selectable
              />
              <Grid className="borrower-loan-grid">
                <Grid.Row>
                  <Grid.Column key={"loanDrawDetailConfirmation"} width={isGreaterThanMobile ? 6 : 16}>
                    <div className="borrower-loan-checkbox"><BCFormInput
                      value={loanDrawDetailConfirmationObj.needInspection}
                      type="checkbox"
                      labelClass="gmr-background-label"
                      obj={loanDrawDetailConfirmationObj}
                      field="needInspection" // TODO: need to find out the actual field name
                      handleFormChange={(value, field) => handleFormChange(value, field, loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj)}
                    /><label>I need to meet the inspectior onsite. I understand an additional $60.00 fee will be applied to my loan balance.</label></div>
                  </Grid.Column>
                  <Grid.Column  width={isGreaterThanMobile ? 6 : 16}>
                    <BCFormInput
                      type="textarea"
                      inputKey="loanDrawDetailConfirmation"
                      placeholder="Enter the best time to meet with your inspector"
                      obj={loanDrawDetailConfirmationObj}
                      field="timeForInspection" // TODO: need to find out the actual field name
                      handleFormChange={(value, field) => handleFormChange(value, field, loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj)}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column key={"loanDrawDetailConfirmation"} width={isGreaterThanMobile ? 6 : 16}>
                    <div className="borrower-loan-checkbox"><BCFormInput
                      value={loanDrawDetailConfirmationObj.needInspection}
                      type="checkbox"
                      labelClass="gmr-background-label"
                      obj={loanDrawDetailConfirmationObj}
                      field="needInspection" // TODO: need to find out the actual field name
                      handleFormChange={(value, field) => handleFormChange(value, field, loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj)}
                    /><label>An inspection is not needed for this draw request.</label></div>
                  </Grid.Column>
                  <Grid.Column  width={isGreaterThanMobile ? 6 : 16}>
                    <BCFormInput
                      type="textarea"
                      inputKey="loanDrawDetailConfirmation"
                      placeholder="Please enter a reason for waiving the inspection on this round of requests."
                      obj={loanDrawDetailConfirmationObj}
                      field="waiveInspectionReason" // TODO: need to find out the actual field name
                      handleFormChange={(value, field) => handleFormChange(value, field, loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj)}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={3}>
                  <Grid.Column key={"loanDrawDetailConfirmation"}>
                    <div className="borrower-loan-checkbox"><BCFormInput
                      value={loanDrawDetailConfirmationObj.additionalDetail}
                      type="checkbox"
                      labelClass="gmr-background-label"
                      obj={loanDrawDetailConfirmationObj}
                      field="additionalDetail" // TODO: need to find out the actual field name
                      handleFormChange={(value, field) => handleFormChange(value, field, loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj)}
                    /><label>I need to provide more details</label></div>
                  </Grid.Column>
                  <Grid.Column>
                  <div className="borrower-loan-dropdown"><BCFormInput 
                      label="Select from the list below to contact Builders Capital, our inspection partner or both."
                      labelClass="gmr-background-label"
                      inputKey={"contact-for-loan-detail"}
                      type="dropdown"
                      placeholder="Please Select"
                      obj={loanDrawDetailConfirmationObj}
                      field="contact" // TODO: need to find out the actual field name
                      value={loanDrawDetailConfirmationObj.contact}
                      // dropdownOptions={getDropdownOptions(applicationMetadata.assetTypes, ["id"], "name")} // TODO: need to ask Salam
                      handleFormChange={(value, field) => handleFormChange(value, field, loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj)}
                    /></div>
                  </Grid.Column>
                  <Grid.Column>
                    <BCFormInput
                      type="textarea"
                      inputKey="additional-comment"
                      placeholder="Enter Comment here"
                      obj={loanDrawDetailConfirmationObj}
                      field="additionalComment" // TODO: need to find out the actual field name
                      handleFormChange={(value, field) => handleFormChange(value, field, loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj)}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <div className="borrower-loan-dropdown"><BCFormInput 
                      label="Bank"
                      labelClass="gmr-background-label"
                      inputKey={"loan-detail-key"}
                      type="dropdown"
                      placeholder="Please Select"
                      obj={loanDrawDetailConfirmationObj}
                      field="bank" // TODO: need to find out the actual field name
                      value={loanDrawDetailConfirmationObj.bank}
                      // dropdownOptions={getDropdownOptions(applicationMetadata.assetTypes, ["id"], "name")} // TODO: need to ask Salam
                      handleFormChange={(value, field) => handleFormChange(value, field, loanDrawDetailConfirmationObj, setLoanDrawDetailConfirmationObj)}
                    /></div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            </React.Fragment>
            : <BCEmptyState
              emptyStateClass="home-content-empty-state"
              icon="file alternate"
              text="There is no loan details to confirm."
            />
          }
        </React.Fragment>
      }
    ]
  ];

  return (
    <div className={(isGreaterThanTablet && isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
      <BCDashboard
        DashboardLayout={LoanDetailProcessLayout}
        dashboardHeaderOptions={true}
      />
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <button onClick={() => console.log(brokerColor)}>brokerColor</button>
        <button onClick={() => console.log(loanProps)}>loanProps</button>
        <button onClick={() => console.log(loanProps.loanDrawRequestInfo.length)}>loanProps.loanDrawRequestInfo.length</button>
      </React.Fragment>}
    </div>
  );
};

export default BWLoanDrawDetailProcess;